import { render } from "./income.vue?vue&type=template&id=21689f94&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=21689f94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21689f94"

export default script